import React from 'react'
// import FeaturedImage from './FeaturedImage'
// import useWpJson from '../Hooks/useWpJson'
// import BackgroundImage from '../wp-adons/BackgroundImage'
// import ResponsiveImage from './ResponsiveImage'
export default function PostComponent (post) {
  // const featuredImage = useWpJson(`media/${post?.featured_media}`)
  return (
    <div
      className='mb-4 relative w-dvw flex flex-col items-center justify-center z-0'
      id={post?.id}
    >
      {/* <div className='fixed z-[-1] w-full h-full top-0 left-0'>
        {featuredImage?.length > 0 ? (
          <FeaturedImage {...featuredImage} />
        ) : (
          <BackgroundImage background_image={post?.acf?.background_image} />
        )}
      </div> */}

      <div className='backdrop-blur-md relative max-w-sitemax w-full m-auto mt-24'>
        <span className='absolute bg-white/50 w-full h-full z-0'></span>
        <p
          className='text-header1 relative z-10 bg-white w-full p-8 '
          dangerouslySetInnerHTML={{ __html: post.title.rendered }}
        />
        <div
          className='flex flex-col relative z-10 px-8 py-4  text-header4 wp-html-box'
          dangerouslySetInnerHTML={{ __html: post.content.rendered }}
        />
      </div>
    </div>
  )
}
